import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import * as styles from "./styles.css";

type Props = {
  shopNames: string[];
  onClickReadMore: () => void;
  showReadMoreButton: boolean;
};

export const Presentation: FC<Props> = ({ shopNames, onClickReadMore, showReadMoreButton }) => {
  return (
    <GuidanceBox>
      <ul className={styles.wrapper}>
        {shopNames.map((shopName) => (
          <li key={shopName} className={styles.list}>
            {shopName}
          </li>
        ))}
        {showReadMoreButton && (
          <div className={styles.buttonContainer}>
            <button type="button" className={styles.button} onClick={onClickReadMore}>
              <span className={styles.text}>続きを見る</span>
            </button>
          </div>
        )}
      </ul>
    </GuidanceBox>
  );
};
